import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/focus-modal-calendar.svg'
import _imports_1 from '@/assets/focus-modal-user-icon.svg'
import _imports_2 from '@/assets/focus-mode-edit-pencil.svg'


const _hoisted_1 = { class: "w-full h-full flex flex-col overflow-y-auto" }
const _hoisted_2 = { class: "relative w-full h-[calc(100vh-233px)]" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "w-full h-[92px] flex flex-col sm:flex-row gap-2 mt-2" }
const _hoisted_5 = { class: "min-w-[208px] max-w-[208px] py-1 px-2 bg-[#F9F8F6] rounded-primary-radius" }
const _hoisted_6 = { class: "text-[#393840] text-base leading-[26px] tracking-[0.01rem] font-medium pb-1" }
const _hoisted_7 = { class: "flex items-center gap-1 mb-[2px]" }
const _hoisted_8 = { class: "text-[#616068] text-sm leading-[20px] font-normal" }
const _hoisted_9 = { class: "h-[20px] overflow-y-auto flex items-start gap-1" }
const _hoisted_10 = { class: "flex flex-wrap items-center gap-1" }
const _hoisted_11 = { class: "w-full flex items-center justify-between" }
const _hoisted_12 = { class: "text-[#393840] text-base leading-[26px] tracking-[0.01rem] font-medium" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "text-[#616068] text-sm leading-5 font-normal" }
const _hoisted_15 = {
  key: 1,
  class: "h-[55px] overflow-y-auto"
}
const _hoisted_16 = { class: "text-[#616068] text-sm leading-5 font-normal" }


import FocusModeNoteModal from "./FocusModeNoteModal.vue";
import { useTranslate } from "@/composables/useTranslate";
import { FocusImage } from "@/types";

type Props = {
  image: FocusImage | null;
  isFocusModeNoteModalOpen: boolean;
};

type Emits = {
  (event: "onAddImageComment", comment: string, logId: number): void;
  (event: "onDeleteImageComment"): void;
  (event: "onNoteModalToggle"): void;
  (event: "onNextImage"): void;
  (event: "onPreviousImage"): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'FocusModeModalMain',
  props: {
    image: {},
    isFocusModeNoteModalOpen: { type: Boolean }
  },
  emits: ["onAddImageComment", "onDeleteImageComment", "onNoteModalToggle", "onNextImage", "onPreviousImage"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;
const { t } = useTranslate();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (__props.isFocusModeNoteModalOpen)
          ? (_openBlock(), _createBlock(FocusModeNoteModal, {
              key: 0,
              "is-modal-open": __props.isFocusModeNoteModalOpen,
              image: __props.image,
              onOnClose: _cache[0] || (_cache[0] = ($event: any) => (emits('onNoteModalToggle'))),
              onOnAddImageComment: _cache[1] || (_cache[1] = 
      (comment, logId) => emits('onAddImageComment', comment, logId)
    ),
              onOnDeleteImageComment: _cache[2] || (_cache[2] = ($event: any) => (emits('onDeleteImageComment')))
            }, null, 8, ["is-modal-open", "image"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          class: "w-full h-full object-contain rounded-primary-radius",
          src: __props.image?.imageUrl,
          alt: "Image"
        }, null, 8, _hoisted_3),
        _createElementVNode("div", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (emits('onPreviousImage'))),
          class: "absolute z-10 top-0 left-0 bottom-0 w-1/4 h-full bg-transparent cursor-pointer"
        }),
        _createElementVNode("div", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (emits('onNextImage'))),
          class: "absolute z-10 top-0 right-0 bottom-0 w-1/4 h-full transparent cursor-pointer"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h4", _hoisted_6, _toDisplayString(_unref(t)("focus_mode_modal.more_info")), 1),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_7, [
              _cache[6] || (_cache[6] = _createElementVNode("img", {
                src: _imports_0,
                alt: "Calendar"
              }, null, -1)),
              _createElementVNode("span", _hoisted_8, _toDisplayString(__props.image?.createdAt
                ? new Date(__props.image?.createdAt).toLocaleDateString("DE")
                : ""), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[7] || (_cache[7] = _createElementVNode("img", {
                src: _imports_1,
                alt: "User"
              }, null, -1)),
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.image?.workers, (worker) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: worker.id,
                    class: "text-[#616068] text-sm leading-[20px] font-normal"
                  }, _toDisplayString(worker.fullname), 1))
                }), 128))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (emits('onNoteModalToggle'))),
          class: "w-full h-[92px] py-1 px-2 bg-[#F9F8F6] rounded-primary-radius cursor-pointer"
        }, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("h4", _hoisted_12, _toDisplayString(_unref(t)("focus_mode_modal.note")), 1),
            _cache[8] || (_cache[8] = _createElementVNode("button", { class: "flex items-center justify-center" }, [
              _createElementVNode("img", {
                src: _imports_2,
                alt: "Pencil"
              })
            ], -1))
          ]),
          (!__props.image?.comment)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(t)("focus_mode_modal.no_note")), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("span", _hoisted_16, _toDisplayString(__props.image?.comment), 1)
              ]))
        ])
      ])
    ])
  ], 64))
}
}

})